module.exports = __webpack_public_path__ + "media/images/icon_job_category1_sp-cfb649dcf6da70c57eb50a0bdf9028e6.png";